<template>
	<div class="featured_people_listing">
		<div class="container">
			<div class="inner">
				<div class="cta-wrapper">
					<primary-button
					:link="parsedCta ? parsedCta : parsedCta.link"
					:label="
						parsedCta.title
							? parsedCta.title
							: parsedCta.link
							? parsedCta.link.title
							: '_self'
					"
				></primary-button>
				</div>
			</div>
		</div>
		<div class="container">
			<div class="left">
				<h2 v-html="description"></h2>
			</div>
			<div class="right">
				<person-tile
					v-for="(person, index) in parsedPeople"
					:image="person.image.url"
					:full_name="person.full_name"
					:position="person.position"
					:bio="person.bio"
					:excerpt="person.excerpt"
					:linkedin="person.linkedin"
					:team_tile_type="person.team_tile_type"
					:phone="person.phone"
					:email="person.email"
					:key="index"
					:class="{ 'full-width': Object.keys(parsedPeople).length <= 1 }"
					data-aos="fade-up"
					data-aos-duration="300"
					:data-aos-offset="50"
					:data-aos-delay="index * 50"
				></person-tile>
			</div>
		</div>
	</div>
</template>

<script>
import PersonTile from './PersonTile.vue';
import PrimaryButton from './PrimaryButton.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			swiper: null,
		};
	},

	props: {
		title: {},
		description: {},
		cta: {},
		people: {},
		type: {},
		section_id: {},
		no_slider: {
			default: 'false',
		},
	},

	computed: {
		parsedPeople() {
			if (this.people) {
				return JSON.parse(this.people);
			} else {
				return null;
			}
		},

		parsedCta() {
			if (this.cta) {
				return JSON.parse(this.cta);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {
		PersonTile,
		PrimaryButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_people_listing {
	background: var(--fpe-light-grey);
	padding-bottom: 50px;

	.template-team & {
		background: transparent;
		margin-top: 50px;
	}

	.container {
		column-gap: 48px;

		&:last-of-type {
			margin-top: 24px;
		}

		.left {
			grid-column: span 3;
			display: flex;
			flex-direction: column;

			@media (max-width: $mobile) {
				grid-column: span 4;
			}

			h2 {
				padding-right: 50px;
				margin-top: 0;
				font-family: var(--primary-font-family-heading);
			}
		}

		.right {
			grid-column: span 9;
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			gap: 0;

			@media (max-width: $mobile) {
				grid-column: span 4;
				grid-template-columns: repeat(4, 1fr);
			}
		}
	}

	.inner {
		grid-column: 1 / span 12;
		margin-top: 48px;
		border-top: 1px solid var(--white);
		padding-top: 24px;
		display: grid;
		grid-template-columns: repeat(12, 1fr);
		column-gap: 24px;

		@media (max-width: $mobile) {
			grid-column: span 4;
			grid-template-columns: repeat(4, 1fr);
		}

		.cta-wrapper {
			grid-column: 4 / span 9;

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeaturedPeopleListing.vue